import { render, staticRenderFns } from "./InsuranceInterest.vue?vue&type=template&id=b3875ac2&scoped=true&"
import script from "./InsuranceInterest.vue?vue&type=script&lang=js&"
export * from "./InsuranceInterest.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceInterest.vue?vue&type=style&index=0&id=b3875ac2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3875ac2",
  null
  
)

export default component.exports